<app-header class="header"></app-header>

<main class="page crm-scroll" #pageScroll>
  <section class="content">
    <div class="main-section">
      <router-outlet></router-outlet>
    </div>
  </section>
  <app-pricing *ngIf="router.url !== '/terms-of-use' && router.url !== '/privacy-policy'"></app-pricing>
  <app-footer class="footer"></app-footer>
</main>
